import { LetterSpacingIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC, useState } from 'react'

export const ToggleMeasurementLabelsButton: FC = () => {
  const { sendCommand } = useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrel()
  const [labelsVisible, setLabelsVisible] = useState(true)

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Toggle Measurements'}>
      <ViewToggle
        onClick={() => {
          setLabelsVisible(!labelsVisible)
          sendCommand({
            command: KestrelCommands.SET_MEASUREMENT_LABEL_VISIBILITY,
            labelsVisible: !labelsVisible,
          })
          trackButtonClicked({
            button_name: 'kestrel_toggle_measurements',
            kestrel_model_id: kestrelModel?.data.kestrel_model_id,
          })
        }}>
        {labelsVisible ? (
          <LetterSpacingIcon
            style={{ color: 'white' }}
            width={22}
            height={22}
          />
        ) : (
          <LetterSpacingIcon style={{ color: 'gray' }} width={22} height={22} />
        )}
      </ViewToggle>
    </TooltipWrapper>
  )
}
